import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csbreak(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };


return(
    <div>
       <Sides/>
      <Helmet>
 
 <title>Learn Free PHP Break Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Break tutorial for beginners,When a Php break is encountered inside any loop, control automatically passes to the first statement after the loop" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,php break out of if,php break foreach,php break loop,php break for loop,php foreach break,break in php,Php break for loop,end for loop Php,Php exit for loop" />
 <link rel="canonical" href="https://www.codeexampler.com/php-break" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Break</h1>
    <div className="first">
        <a href="/php-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">1, Php break keyword is used to  exit from loop and switch<br/>
2, When a Php break Encounter inside any loop, control automatically passes to the first statement after the loop.<br/>
3, Break in Php break statement is used to terminate a loop immediately. The break statement Encounter inside a loop<br/>
</p>
<h2 className="mt-4 mh2">The syntax for Php break:</h2>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"} 
              <span className="qwerty-4"> Break</span>
              <span className="qwerty-3">;</span>
              {"\n"} 
              {"\n"} 
            
          </code>
        </pre>
      </div>  



<h2 className="headings">Q-Write a program loop start from 1 to 10 but break on 5 and Show Output?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-2">for </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">i </span>
            <span className="qwerty-5">= </span>
            <span className="qwerty-2">1</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-5">;</span>
            <span className="qwerty-2">$</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-10"> ++</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">if </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-2">$</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-5"> == </span>
            <span className="qwerty-2">5</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-10">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">echo </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-2">i </span>
            <span className="qwerty-3">."</span>

            <span className="qwerty-10">\</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-6">1 </span>
              {"\n"}
              <span className="qwerty-6">2 </span>
              {"\n"}
              <span className="qwerty-6">3 </span>
              {"\n"}
              <span className="qwerty-6">4 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


<h2 className="headings">Q-Write a program Break on first, even no in Php Break for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-2">for </span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">i </span>
            <span className="qwerty-5">= </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-5"> $</span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-5">;</span>
            <span className="qwerty-2">$</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-10"> ++</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-3">if </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-2">$</span>
            <span className="qwerty-3">i</span>
            <span className="qwerty-2"> % </span>
            <span className="qwerty-6">2</span>
            <span className="qwerty-5"> == </span>
            <span className="qwerty-6">0</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">echo </span>
            <span className="qwerty-5">$</span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

      <h2 className="headings">output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
          <span className="qwerty-6">1 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  



<h2 className="headings">Q-Write a program Break if i=4 and show output in Php Break for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">for </span>
            <span className="qwerty-5">(</span>
              <span className="qwerty-3">$</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-4">1</span>
            <span className="qwerty-2">; </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-2">; </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-2">if </span>
            <span className="qwerty-5">(</span>
              <span className="qwerty-3">$</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-2">== </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-5">)</span>
            {"\n"}
            <span className="qwerty-3">break</span>
            <span className="qwerty-2">;</span>
            {"\n"}
            <span className="qwerty-7">echo </span>
            <span className="qwerty-10">("</span>
            <span className="qwerty-6">That is </span>
            <span className="qwerty-5">Break</span>
            <span className="qwerty-2">".</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-2">."</span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">br/</span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10">");</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-7">echo </span>
              <span className="qwerty-2">("</span>
            <span className="qwerty-3">Break</span>
            <span className="qwerty-5"> Complete</span>
            <span className="qwerty-2">");</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
            <span className="qwerty-6">That is </span>
            <span className="qwerty-5">Break </span>
            <span className="qwerty-7">1</span>
            {"\n"}
            <span className="qwerty-6">That is </span>
            <span className="qwerty-5">Break </span>
            <span className="qwerty-7">2</span>
            {"\n"}
            <span className="qwerty-6">That is </span>
            <span className="qwerty-5">Break </span>
            <span className="qwerty-7">3</span>
            {"\n"}
            <span className="qwerty-5">Break</span>
            <span className="qwerty-4"> Complete </span>
            {"\n"}
            {"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/php-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csbreak;